import { Button } from 'alurkerja-ui';
import React, { PropsWithChildren } from 'react';

interface OutlineButtonProps extends PropsWithChildren {
  icon?: React.ReactNode;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export const OutlineButton: React.FC<OutlineButtonProps> = ({
  icon,
  children,
  onClick,
  isLoading,
  disabled,
}) => {
  return (
    <Button
      variant="outlined"
      type="button"
      // @ts-expect-error element/node
      icon={icon}
      className={`shadow-md hover:shadow-none ${disabled ? 'bg-gray-300 cursor-not-allowed shadow-none' : ''}`}
      onClick={onClick}
      loading={isLoading}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
